module.exports = __webpack_public_path__ + "img/extended.45fbe850.png";